"use strict";

import { ethers } from "ethers";
import { erc20Abi } from "viem";

class TransferTokensService {
  async sendNativeTokens({
    signer,
    to,
    value,
    decimals,
    provider,
  }) {
    const tx = await signer.sendTransaction({
      to,
      value: ethers.parseUnits(value, decimals),
    });

    await provider.waitForTransaction(tx.hash, 1);

    const receipt = await provider.getTransactionReceipt(tx.hash);

    if (receipt?.status === 0) {
      console.error(tx);

      throw new Error("Transaction error");
    }
  }

  async getMaxTokensAmount({
    provider,
    to,
    value,
    walletAddress,
    decimals,
  }) {
    const gasLimit = await provider.estimateGas({
      to,
      value: ethers.parseUnits(value, decimals),
    });
    const gasPrice = (await provider.getFeeData()).gasPrice || 0n;
    const balance = await provider.getBalance(walletAddress);
    const multiplier = ethers.parseUnits("2", decimals);
    const gasCost =
      (gasPrice * gasLimit * multiplier) / ethers.parseUnits("1", decimals);

    if (balance >= gasCost) {
      const maxSendableValue = balance - gasCost;

      if (maxSendableValue <= 0n) {
        throw new Error("Insufficient balance to cover gas fees");
      } else {
        const maxSendableValueInEth = ethers.formatUnits(
          maxSendableValue,
          decimals
        );

        return maxSendableValueInEth;
      }
    } else {
      throw new Error("Insufficient balance to cover gas fees");
    }
  }

  async sendToken({
    tokenAddress,
    to,
    amount,
    signer,
    decimals,
    provider,
  }) {
    const tokenContract = new ethers.Contract(tokenAddress, erc20Abi, signer);
    const amountInUnits = ethers.parseUnits(amount, decimals);

    const tx = await tokenContract.transfer(to, amountInUnits);

    await provider.waitForTransaction(tx.hash, 1);

    const receipt = await provider.getTransactionReceipt(tx.hash);

    if (receipt?.status === 0) {
      console.error(tx);

      throw new Error("Transaction error");
    }
  }
}

export const transferTokensService = new TransferTokensService();
